import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	createContainer,
	createSubscriber,
	defaultRegistry,
} from '@atlassian/react-sweet-state';
import { fg } from '@atlassian/jira-feature-gating';
import { fireAddTeammatetoJiraAnalytics } from './analytics/index.tsx';
import type { State, Actions, ContainerProps, ContextConfig } from './types.tsx';

const CONTROLLER_NAME = 'invite-people-modal';

const initialState: State = {
	isOpen: false,
	inviteFlow: 'unknown',
	continueUrl: undefined,
	source: undefined,
	subProduct: undefined,
	userInput: undefined,
};

const Store = createStore<State, Actions>({
	name: CONTROLLER_NAME,
	initialState,
	actions: {
		openModal:
			(
				createAnalyticsEvent: CreateUIAnalyticsEvent | null,
				{
					inviteFlow,
					analyticsSource,
					continueUrl,
					source,
					subProduct,
					analyticsAttributes,
					userInput,
				}: ContextConfig,
			) =>
			({ setState }) => {
				fireAddTeammatetoJiraAnalytics({
					createAnalyticsEvent,
					inviteFlow,
					analyticsSource,
					source,
					analyticsAttributes,
				});

				setState({
					isOpen: true,
					inviteFlow,
					continueUrl,
					source,
					subProduct,
					...(fg('jira_invites_autofill_email_domain_fg') && { userInput }),
				});
			},
		closeModal:
			() =>
			({ setState }) =>
				setState(initialState),
	},
});

export const useInvitePeopleModal = createHook(Store);
export const InvitePeopleModalProvider = createContainer<State, Actions, ContainerProps>(Store, {
	onInit:
		() =>
		({ setState }, { isOpen }) => {
			setState({ isOpen });
		},
});

export const InvitePeopleModalSubscriber = createSubscriber<
	State,
	Actions,
	boolean,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any>
>(Store, {
	displayName: 'InvitePeopleModalSubscriber',
	selector: (state: State) => state.isOpen,
});

export const triggerOpenModal = (
	createAnalyticsEvent: CreateUIAnalyticsEvent | null,
	contextConfig: ContextConfig,
): void => {
	defaultRegistry.getStore(Store)?.actions.openModal(createAnalyticsEvent, contextConfig);
};
